export default "__VITE_ASSET__DW4pFU$s__"